module.exports = {
	"header": "SportHälsa and Vinsider partners with Spotin",
	"date": "2022/11/01",
	"imgSrc": "vinsider_sporthalsa.png",
	"imgAlt": "SportHälsa and Vinsider partners with Spotin",
	"ingress": "SportHälsa and Vinsider partners with Spotin to launch 'friction-free content commerce'",
	"sections": [
		{
			"paragraphs": [
				"The web magazines <a href='https://www.sporthalsa.se/' style='text-decoration: underline;'>SportHälsa</a> and <a href='https://www.vinsider.se/' style='text-decoration: underline;'>Vinsider</a> have entered a collaboration with Spotin. In October 2022, both these websites will launch Spotin’s content commerce solution that will allow their site visitors to shop from within content without being redirected to a seller’s site.",
				"Since 2006, Sporthälsa has offered great content in the fitness and health genre with a wide variety of content from ‘training exercises’ to ‘dinner recipes’ etc. Vinsider, as the name reveals ‘an insider to the wine world’ creates content around wine and food. The two sites are now able to enhance their user experience by offering product sales at the point of discovery, making shopping fun and friction-free.",
				"Spotin's technology is helping these sites offer seamless shopping experiences that allow the site readers to shop from within editorial content, without being linked away to a seller’s website. The change that Spotin is bringing is also for the brands and sellers to have their products available for sale whenever their customer discovers them in any form of content.",
				"The initial launch will offer purchase of books from Bonnierförlagen, but soon there can be possibilities of more products from other categories, along with Spotin enabled e-shop, that will offer a curated shopping experience."
			],
			"quote": {
				"text": "“We look forward to offering our readers a new way to get indepth information about products and the possibility to shop directly on our sites. The idea is that when our visitors read a recipe or a lifestyle tip and get inspired, they have the possibility to buy the book that its originally from. We see lots of advantages with this and we are excited to connect inspiration with the possibility of purchase.”",
				"author": "Oskar Lindholm",
				"title": "CEO of SportHälsa and Vinsider"
			}
		},
		{
			"quote": {
				"text": "“We are glad that SportHälsa and Vinsider have chosen to use Spotin’s content commerce solution to offer their readers friction-free shopping. We look forward to bringing together publishers and brands to open new revenue streams for all parties.”",
				"author": "Kristoffer Karlsson",
				"title": "CEO & Founder at Spotin"
			}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/11/article.json
// module id = 9
// module chunks = 0